interface WhyNativeTreesProps {
  image: string
  description: string
}

export const whyNativeTrees: WhyNativeTreesProps[] = [
  {
    image: '/img/why-native-trees/w-n-t-1.png',
    description:
      'They store carbon from our atmosphere and help reduce the effects of climate change.'
  },
  {
    image: '/img/why-native-trees/w-n-t-2.png',
    description:
      'They clean up waterways, protect downstream ecosystems, and help reduce flood risk.'
  },
  {
    image: '/img/why-native-trees/w-n-t-3.png',
    description:
      'We climb them, swing from them, and play in them—they play a big part in providing environments for recreation.'
  },
  {
    image: '/img/why-native-trees/w-n-t-4.png',
    description:
      'They improve our mental wellbeing. Views of nature such as our beautiful native forests reduce stress in our bodies and minds: especially for people usually in urban conditions.'
  },
  {
    image: '/img/why-native-trees/w-n-t-5.png',
    description:
      'They provide habitat and food sources for our native birds, bees, insects and invertebrates.'
  },
  {
    image: '/img/why-native-trees/w-n-t-6.png',
    description:
      'They can contribute to nutrient recycling, absorbing nutrients from intensive agriculture.'
  },
  {
    image: '/img/why-native-trees/w-n-t-7.png',
    description:
      'They are vital for stabilising soils, reducing sedimentation, moderating erosion.'
  },
  {
    image: '/img/why-native-trees/w-n-t-8.png',
    description:
      'They give us a sense of national identity (symbols like Silver Fern or koru).'
  },
  {
    image: '/img/why-native-trees/w-n-t-9.png',
    description:
      'They are economically important. Many industries rely on native trees: from honey production and timber value, to extracting oils for skincare.'
  },
  {
    image: '/img/why-native-trees/w-n-t-10.png',
    description:
      'They provide habitat for food sources like whitebait, wild game, kōura and pikopiko.'
  },
  {
    image: '/img/why-native-trees/w-n-t-11.png',
    description:
      'They are part of the New Zealand experience, highly valued by tourists.'
  },
  {
    image: '/img/why-native-trees/w-n-t-12.png',
    description: 'They help our physical health.'
  },
  {
    image: '/img/why-native-trees/w-n-t-13.png',
    description:
      'They provide shade, not just for people but also for livestock.'
  },
  {
    image: '/img/why-native-trees/w-n-t-14.png',
    description: 'They provide medicinal benefits.'
  },
  {
    image: '/img/why-native-trees/w-n-t-15.png',
    description: `They can live for thousands of years. Unlike pine, they don't need to be clear-felled and replanted—they keep thriving.`
  },
  {
    image: '/img/why-native-trees/w-n-t-16.png',
    description:
      'More native trees = greater indigenous biodiversity, meaning greater resilience and a bigger range of functions within our ecosystems.'
  },
  {
    image: '/img/why-native-trees/w-n-t-17.png',
    description:
      'They improve the quality of our air, absorbing carbon dioxide and emitting oxygen. Research shows Kiwi kids who spend more time surrounded by nature are less likely to develop asthma.'
  },
  {
    image: '/img/why-native-trees/w-n-t-18.png',
    description: `They're culturally significant in Māori heritage and myth; they're part of our whakapapa in the domain of Tāne Mahuta.`
  },
  {
    image: '/img/why-native-trees/w-n-t-19.png',
    description: `New Zealand's natural forests provide a backdrop for activities to connect with one another and create lasting memories: think volunteering, tramping, climbing, sailing, swimming, picnicking, walking and cycling.`
  },
  {
    image: '/img/why-native-trees/w-n-t-5.png',
    description:
      'Our native forests provide learning opportunities at many levels of education, and there is evidence that some forms of learning are enhanced in natural settings.'
  }
]
